import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from "react-device-detect";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';

import AutoCarousel from "./AutoCarousel";

const useStyles = makeStyles((theme) => ({
  root: {
		padding: theme.spacing(2),
		display: 'flex', 
		flexDirection: 'column',
	},
	contact_title: {
		fontFamily: "Open Sans, Lato, Muli",
		color: '#03234b',
  	letterSpacing: '.015em',
  	fontWeight: 800,
   	fontSize: 'calc(22px + 0.6vw)',
	},
	content_1: {
		fontSize: (isMobile) ? 'calc(12px + 0.5vw)': 'calc(10px + 0.4vw)',
		fontFamily: "Open Sans, Muli, Lato",
  	color: '#03234b',
  	textAlign: (isMobile) ? 'left' : 'justify',
		padding: (isMobile) ? '4% 0 0 0'  : '2% 0 0 0',
	},
	list_root: {
		margin: (isMobile) ? '5% 0 0 0' : '5% 0% 0% 0%',
	},
	list_row: {
		width: '100%',
		display: 'flex', 
		flexDirection: 'row',
		flexGrow:1,
  	flexShrink:1,
  	justifyContent: 'space-between',
	},
	list_column: {
		width: '100%',
		display: 'flex', 
		flexDirection: 'column',
		flexGrow:1,
  	flexShrink:1,
  	justifyContent: 'space-between',
	},
	card: {
		width: (isMobile) ? '92%' : '80%',
		margin: (isMobile) ? '2% 0 2% 0' : '0.5%',
		padding: (isMobile)? '5%' : '2.5%',
		minHeight:  (isMobile)?  'calc(100px + 4vw)' : 'calc(60px + 2vw)',
		background: '#fff',
		display:'flex',
    flexDirection: 'column',
    alignItems: 'center',
	},
	icon: {
		height:  (isMobile)?  'calc(80px + 8vw)' : 'calc(90px + 4vw)',
		width: '100%', 
		backgroundSize: '100% 100%', 
 		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
		marginBottom : '5%',
	},
	list_content_1: {
		padding: (isMobile) ? '4% 0 0 0'  : '4% 0 0 0', 
		width: '100%',
		color:'#03234b', 
		fontFamily: "Open Sans, Muli, Lato",
		fontWeight: 800,
		letterSpacing: '0.1em',
		fontSize: (isMobile) ? 'calc(16px + 0.6vw)': 'calc(15px + 0.3vw)',
		textTransform: 'uppercase',
		display: 'flex',
		justifyContent: 'center',
		textAlign: 'center'
	},
	banner: {
		paddingTop: (isMobile) ? '4%' : '2%',
	},
	list_content_2: {
		padding: (isMobile) ? '4% 0 0 0'  : '2% 0 0 0', 
		color:'#03234b', 
		fontFamily: "Open Sans, Muli, Lato",
		fontWeight: 600,
		fontSize: (isMobile) ? 'calc(12px + 0.5vw)': 'calc(10px + 0.4vw)',
		display: 'flex',
		justifyContent: 'center',
		textAlign: 'center'
	},

}));

const items = [
	{img: 'iot/iot1.jpeg'},
	{img: 'iot/iot2.png'},
	{img: 'iot/iot3.jpg'},
];

const specialize= [
	[
		{
			title: 'INDUSTRIES', 
			img: 'iot/industries.jpg', 
			content: '',
		},
		{	
			title: 'AGRICULTURE', 
			img: 'iot/agriculture.jpg', 
			content: '',
		},
		{ 
			title: 'HEALTH CARE', 
			img: 'iot/health_care.jpg', 
			content: '',
		},
	],
	[
		{
			title: 'ENVIRONMENTAL', 
			img: 'iot/environmental.jpg', 
			content: '',
		},
		{
			title: 'TRANSPORT AND LOGISTICS', 
			img: 'iot/transport.jpg', 
			content: '',
		},
		{
			title: 'ENERYGY', 
			img: 'iot/energy.jpg', 
			content: '',
		},
	],
]; 

function WebDevelopment() {
	const classes = useStyles();
	window.scrollTo(0, 0);
	
  return (
    <div id='orbidx-iot' className={classes.root}>
    	<div className={classes.contact_title}>
				INTERNET OF THINGS 
			</div>
			<div className={classes.banner}>
				<AutoCarousel items={items} indicators={false}/>
			</div>
			<div className={classes.content_1}>
				We deliver secure, cost-effective, low power IoT devices with multiple 
				communication protocol and network protocol based on application needs.   
			</div>
			<div className={classes.content_1}>
				IoT domain we deliver solutions
			</div>
			<div className={classes.list_root}>
			{
				specialize.map((row, index) =>
				<div 
					id={index} 
					className={(isMobile) ? classes.list_column : classes.list_row}
				>
				{
					row.map((element, index) =>  
						<Paper 
							elevation={1}
							id={element.title} 
							className={classes.card}
						>
							<div 
								className={classes.icon} 
								style={{
									backgroundImage: `url(${require(`./assets/${element.img}`)})`
								}}
							>
							</div>
							<div className={classes.sub_card}>
								<div className={classes.list_content_1}>
									{element.title}
								</div>
							</div>
						</Paper>
					)
				}
				</div>
				)
			}
			</div>
    </div>
  );
}

export default WebDevelopment;
